'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initNotification = initNotification;
// Action types
var INIT_NOTIFICATION = exports.INIT_NOTIFICATION = 'INIT_NOTIFICATION';

function initNotification() {
    var notificationInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isActive: false };

    return function (dispatch) {
        return dispatch({
            type: INIT_NOTIFICATION,
            notificationInfo: notificationInfo
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/notification.js
// module id = 780
// module chunks = 0